module.exports = __webpack_public_path__ + "img/Realisme_Kunsten_og_moderniteten3.6701142d.jpg";